import { computed } from "vue";
import { createGlobalState } from "@vueuse/core";

import { LicenceWithSeats } from "@/types/licenceSolutions.ts";
import { useSolutionsStore } from "@/store/solutions.store";

export const useEnabledSolutions = createGlobalState(() => {
  const solutionsStore = useSolutionsStore();

  const enabledSolutions = computed(() =>
    (solutionsStore.solutions as LicenceWithSeats[]).map((solution) => {
      return {
        ...solution,
        service: {
          name: solution.solution_name,
          uuid: solution.solution_uuid,
        },
      };
    }),
  );
  return { enabledSolutions };
});

export default {};
